<template>
  <div>
    <div class="modals">
      <b-modal
        class="modalConfirmPass"
        :modal-class="true ? 'in':''"
        :hide-header-close="true"
        :title-tag="'h4'"
        cancel-title="Annuler"
        id="modalConfirmPass"
        ref="modal"
        title="Changement du mot de passe MyABFT"
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleOk"
      >

        <div class="portlet light " style="margin: 0;padding: 0;">
          <div class="portlet-title">
            <div class="form-group well">
              <form ref="form" @submit.stop.prevent="savePassword" data-vv-scope="form-password">
                <b-form-group
                  :state="passState"
                  label="Mot de passe actuel"
                  label-for="pass-input"
                  invalid-feedback="Le mot de passe est requis"
                >
                  <b-form-input
                    id="pass-input"
                    type="password"
                    v-model="actualPassword"
                    :state="passState"
                    required
                  ></b-form-input>
                </b-form-group>
                <div class="form-group"
                     :class="{'has-error': errors.has('form-password.pass1') }">
                  <label for="pass1">Nouveau mot de passe</label>
                  <input type="password" class="form-control" id="pass1" name="pass1"
                         v-validate="'min:6|max:255'"
                         ref="password1"
                         placeholder="Mot de passe" v-model="pass1">
                  <span v-show="errors.has('form-password.pass1')" class="help-block">Votre mot de passe doit comporter minimum 6 caractères</span>
                </div>
                <div class="form-group"
                     :class="{'has-error': errors.has('form-password.pass2')  || pass1!=pass2 }">
                  <label for="pass2">Confirmation du nouveau mot de passe</label>
                  <input type="password" class="form-control" id="pass2" name="pass2"
                         ref="pass2"
                         v-validate="'min:6|max:255'"
                         placeholder="Mot de passe" v-model="pass2">
                  <span v-show="errors.has('form-password.pass2') || pass1!=pass2"
                        class="help-block ">Vos mots de passe doivent correspondre</span>
                </div>
              </form>
            </div>
          </div>
        </div>
        <template v-slot:modal-footer>
          <button type="button"
                  @click.prevent="hideModal"
                  class="btn btn-secondary">
            Annuler
          </button>
          <button type="button"
                  @click.prevent="savePassword"
                  :disabled="!actualPassword || !pass1 || !pass2 || pass1!=pass2 || errors.has('form-password.pass2')"
                  class="btn btn-primary">Sauvegarder
          </button>
        </template>
      </b-modal>
    </div>

    <section class="content-header">
      <div v-if="!getMember.isLicencie"
           class="alert alert-error alert-dismissible"
           style="margin-top: 0;">
        Attention! Vous n'êtes actuellement pas licencié à l'A.B.F.T. pour l'année {{ currentYear() }}
      </div>

      <div v-if="isLessOrEquelTo2Months(getMember.lastLicence.date_fin)"
           class="alert alert-warning alert-dismissible"
           style="margin-top: 0;">
        Attention! Votre licence A.B.F.T. arrivera à expiration le {{getMember.lastLicence.date_fin}}.
      </div>
    </section>
    <section class="content">

      <div class="col-md-6 col-sm-12">
        <div class="portlet light ">
          <div class="portlet-title">
            <div class="caption pull-left">
              <div class="subject">
                <span class="caption-subject">Votre profil</span>
                <span class="caption-helper"></span>
              </div>
              <div class="subsubject">
                Fiche administrative
              </div>
            </div>
          </div>
          <div class="portlet-body">
            <div class="row">
              <div class="col-md-12">

                <!-- Nom Form Input -->
                <div class="form-group">
                  <label for="nom">Nom:</label>
                  <input readonly="1" class="form-control" name="nom" type="text"
                         v-model="getMember.nom" id="nom">
                </div>

                <!-- Prenom Form Input -->
                <div class="form-group">
                  <label for="prenom">Prenom:</label>
                  <input readonly="1" class="form-control" name="prenom" type="text"
                         v-model="getMember.prenom" id="prenom">
                </div>

                <!-- Prenom Form Input -->
                <div class="form-group">
                  <label for="dob">Date de Naissance:</label>
                  <input v-if="getMember.date_naissance" readonly="1" class="form-control" name="dob" type="text"
                         v-model="getMember.date_naissance" id="dob">
                  <input v-if="!getMember.date_naissance" readonly="1" class="form-control" name="dob" type="text"
                         value="Inconnue" id="dob">
                </div>

                <!-- Adresse Form Input -->
                <div class="form-group" :class="{'has-error': errors.has('adresse')}">
                  <label for="adresse">Adresse:</label>
                  <input class="form-control" name="adresse" type="text"
                         v-validate="'required|max:255'"
                         v-model="getMember.adresse" id="adresse">
                </div>
                <!-- Cp Form Input -->
                <div class="form-group" :class="{'has-error': errors.has('cp')}">
                  <label for="cp">Code postal:</label>
                  <input class="form-control" name="cp" type="text"
                         v-validate="'required|max:100'"
                         v-model="getMember.cp" id="cp">
                </div>
                <!-- Ville Form Input -->
                <div class="form-group" :class="{'has-error': errors.has('ville')}">
                  <label for="ville">Ville:</label>
                  <input class="form-control" name="ville" type="text"
                         v-validate="'required|max:255'"
                         v-model="getMember.ville" id="ville">
                </div>

                <div class="form-group">
                  <div class="checkbox">
                    <label for="newsletter" style="font-weight: 400;font-size: 12px;">
                      <input id="newsletter" name="newsletter" type="checkbox"
                             v-model="getMember.newsletter">
                      Je souhaite recevoir la newsletter ABFT concernant les stages, formations, compétitions et autres
                      organisations ABFT.
                    </label>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>

        <div class="portlet light ">
          <div class="portlet-title">
            <div class="caption pull-left">
              <div class="subject">
                <span class="caption-subject">MyABFT</span>
                <span class="caption-helper"></span>
              </div>
              <div class="subsubject">
                Paramètres MyABFT
              </div>
            </div>
          </div>
          <div class="portlet-body prints">
            <div class="row">
              <div class="col-md-12">
                <b-button class="btn btn-primary"
                          v-b-modal.modalConfirmPass
                          type="button"
                >Changer mon mot de passe MyABFT
                </b-button>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="col-md-6 col-sm-12">
        <div class="portlet light ">
          <div class="portlet-title">
            <div class="caption pull-left">
              <div class="subject">
                <span class="caption-subject">Données de contact</span>
                <span class="caption-helper">
                                        <i class="ico-help icons-icon-help" style="display:inline-block"
                                           data-html="true" data-toggle="tooltip" data-placement="right" title=""
                                           data-original-title="Vos données de contact ne sont pas ditribuées à des tiers ni utilisées pour des envois publicitaires. L'ABFT n'utilisera ces données qu'en cas de besoin urgent (sélections, stages, grade, ...) "></i>
                                    </span>
              </div>
              <div class="subsubject">
                Mes données de contact
              </div>
            </div>
          </div>
          <div class="portlet-body">
            <div class="row">
              <div class="col-md-12">
                <!-- Mail Form Input -->
                <div class="form-group" :class="{'has-error': errors.has('mail')}">
                  <label for="mail">Mail:</label>
                  <input class="form-control" name="mail" type="text"
                         v-validate="'required|email|max:255'" v-model="getMember.mail" id="mail">
                </div>
                <!-- Telephone Form Input -->
                <div class="form-group" :class="{'has-error': errors.has('telephone')}">
                  <label for="telephone">Telephone:</label>
                  <input class="form-control" name="telephone"
                         v-validate="'max:30'"
                         type="text" v-model="getMember.telephone" id="telephone">
                </div>
                <!-- Gsm Form Input -->
                <div class="form-group" :class="{'has-error': errors.has('gsm')}">
                  <label for="gsm">Gsm:</label>
                  <input class="form-control"
                         v-validate="'max:30'"
                         name="gsm" type="text" v-model="getMember.gsm" id="gsm">
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="portlet light ">
          <div class="portlet-title">
            <div class="caption pull-left">
              <div class="subject">
                <span class="caption-subject">Impressions</span>
                <span class="caption-helper"></span>
              </div>
              <div class="subsubject">
                Imprimer les documents officiels ABFT
              </div>
            </div>
          </div>
          <div class="portlet-body prints">
            <div class="row">
              <!--              <div class="col-md-6">-->
              <!--                <a :disabled="!checkLicences(getYear()-1)"-->
              <!--                   class="btn btn-primary"-->
              <!--                   @click.prevent="getLicenceDoc(getYear()-1)"-->
              <!--                   href="#">Imprimer la demande de licence {{getYear()-1}}</a>-->
              <!--              </div>-->
              <div class="col-md-6">
                <a :disabled="checkLicences(getYear())"
                   class="btn btn-primary"
                   @click.prevent="getLicenceDoc(getYear())"
                   href="#">Imprimer la demande de licence </a>
              </div>
            </div>
          </div>
        </div>


      </div>

      <div class="col-md-12" v-if="getMember.licences!=null && getMember.licences.length>0">
        <div class="portlet light">
          <div class="portlet-title" :style="{ 'min-height': hasPrevious2007(getLicences()) ? '48px':'32px' }">
            <div class="caption pull-left">
              <div class="subject">
                <span class="caption-subject">Mes affiliations</span>
                <span class="caption-helper"></span>
              </div>
              <div class="subsubject" v-if="hasPrevious2007(getLicences())">
                Pour des raisons techniques, les données antérieures à l'année 2007 ne peuvent être garanties.
              </div>
            </div>
          </div>
          <div class="portlet-body">
            <table class="table table-responsive table-hover">
              <thead>
              <tr>
                <th>Date de début</th>
                <th>Date de fin</th>
                <th>Club</th>
                <!--<th>Apte à la pratique</th>-->
                <!--<th>Apte à la compétition</th>-->
              </tr>
              </thead>
              <tbody>
              <tr v-for="licence in getLicences()">
                <td>{{ licence.date_debut }}</td>
                <td>{{ licence.date_fin }}</td>
                <td>{{ licence.club }}</td>
                <!--<td>-->
                <!--<span class="text-success text-uppercase" v-if="licence.apte_pratique"><strong>OUI</strong></span>-->
                <!--<span class="text-danger text-uppercase" v-if="!licence.apte_pratique"><strong>NON</strong></span>-->
                <!--</td>-->
                <!--<td>-->
                <!--<span class="text-success text-uppercase" v-if="licence.apte_competition"><strong>OUI</strong></span>-->
                <!--<span class="text-danger text-uppercase" v-if="!licence.apte_competition"><strong>NON</strong></span>-->
                <!--</td>-->
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row">
          <input
            :disabled="errors.count()!=0"
            @click.prevent="saveProfile()"
            class="btn btn-primary pull-right btnSave"
            type="submit"
            value="Sauvegarder">
        </div>
      </div>
    </section>
  </div>
</template>

<script type="text/babel">
import Auth from '@/auth'
import moment from 'moment/moment'
import {mapGetters, mapActions} from 'vuex'

var FileSaver = require('file-saver');

export default {
  data() {
    return {
      formErrors: [],
      numLicence: "",
      password: "",
      passState: null,
      actualPassword: "",
      pass1: "",
      pass2: "",
    }
  },
  methods: {
    ...mapActions({
      setLoading: 'setLoading',
      setMember: 'setMember',
    }),
    isLessOrEquelTo2Months(annee) {
      return this.getMember.isLicencie &&
        moment(annee, "DD/MM/YYYY").subtract(2,'month').isBefore(moment())
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.savePassword()
    },
    hideModal() {
      this.$bvModal.hide('modalConfirmPass')
    },
    checkFormValidity() {
      return this.actualPassword != ""
    },
    resetModal() {
      this.actualPassword = ""
      this.pass1 = ""
      this.pass2 = ""
    },

    savePassword: function () {
      this.setLoading(true)
      let saveRequest = {
        password: this.pass1,
        actualPassword: this.actualPassword,
      }
      if (!this.checkFormValidity()) {
        this.$noty.error("Le mot de passe ne peut être vide")
        return;
      }

      this.$http.post(process.env.API_URL + "updatePasswordMyABFT", saveRequest)
        .then((response) => {
          this.setLoading(false)
          this.$bvModal.hide('modalConfirmPass')
          this.resetModal()
          this.$noty.success("Votre mot de passe a été correctement modifié. Veuillez vous reconnecter.")
          Auth.logout();
        }, (response) => {
          this.setLoading(false)
          this.$bvModal.hide('modalConfirmPass')
          this.resetModal()
          this.$noty.error("Erreur lors de la sauvegarde de votre mot de passe. Vérifiez le mot de passe entré.")
        })
    },
    getYear() {
      return moment().year();
    },
    getLicenceDoc(year) {
      this.$http.post(process.env.API_URL + "getDemandeLicence",
        {year: year, id_member: this.getMember.id}, {responseType: 'blob'})
        .then((response) => {
          let blob = new Blob([response.body], {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'})
          FileSaver.saveAs(blob, "DemandeLicence" + year + ".docx");
          return response.blob()
          // let link = document.createElement('a')
          // link.href = window.URL.createObjectURL(blob)
          // link.click()
          return true
        }, (response) => {
          return this.$noty.error("Erreur lors de la génération de votre document de licence")
        })
    },
    checkLicences(forYear) {
      this.getLicences().forEach((item) => {
        if (item.annee == forYear)
          return true
      })
      return false
    },
    saveProfile: function () {
      this.setLoading(true)
      let saveRequest = {
        id_member: this.getMember.id,
        adresse: this.getMember.adresse,
        cp: this.getMember.cp,
        ville: this.getMember.ville,
        mail: this.getMember.mail,
        telephone: this.getMember.telephone,
        gsm: this.getMember.gsm,
        newsletter: this.getMember.newsletter
      }

      this.$http.post(process.env.API_URL + "updateInfosMember", saveRequest)
        .then((response) => {
          this.$http.post(process.env.API_URL + "getInfosMember").then((response2) => {
            this.setLoading(false)
            this.$noty.success("Votre profil a bien été sauvegardé")
            this.setMember(response2.body)
          }, (response2) => {
            this.setLoading(false)
            this.$noty.error("Erreur lors de la récupération de votre profil")
          })
        }, (response) => {
          this.setLoading(false)
          this.$noty.error("Erreur lors de la sauvegarde de votre profil")
        })
    },
    currentYear: function () {
      return moment().year();
    },
    getLicences() {
      return _.sortBy(this.getMember.licences, function (licence) {
        return moment(licence.date_fin, "DD/MM/YYYY").year();
      }).reverse();
    },
    hasPrevious2007(table) {
      return _.find(table, function (item) {
        return item.annee < 2007
      })
    }
  },
  components: {},
  computed: {
    ...mapGetters({
      getMember: 'getMember'
    })
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Member/MemberProfile.vue